import {List, Divider, Box, useTheme, useMediaQuery} from "@mui/material";
import DrawerEntry from "./DrawerEntry";
import {MenuItems} from "config/drawer-items";
import CustomDrawerHeader from "./CustomDrawerHeader";
import ThemeColors from "config/colors";
import * as React from "react";
import {styled} from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import CustomDrawerFooter from "./CustomDrawerFooter";
import {DRAWER_WIDTH} from "../../config/constants";


const openedMixin = (theme) => ({
    width: DRAWER_WIDTH,
    overflowX: 'hidden',
    background: ThemeColors.babyBlueColor,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
    }),
});

const closedMixin = (theme) => ({
    // width: `calc(${theme.spacing(6)})`,
    width: 0,
    zIndex: 1201,
    background: ThemeColors.babyBlueColor,
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
});

const Drawer = styled(MuiDrawer, {shouldForwardProp: (prop) => prop !== 'open'})(
    ({theme, open}) => ({
        width: DRAWER_WIDTH,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        background: ThemeColors.whiteColor,

        ...(open && {
            ...openedMixin(theme),
            '& .MuiDrawer-paper': openedMixin(theme),

        }),
        ...(!open && {
            ...closedMixin(theme),
            '& .MuiDrawer-paper': closedMixin(theme),
        }),

        // '&:hover': {
        //     ...openedMixin(theme),
        //     '& .MuiDrawer-paper': {
        //         ...openedMixin(theme),
        //         '&::-webkit-scrollbar': {
        //             width: '12px',
        //         },
        //         '&::-webkit-scrollbar-track': {
        //             background: '#eee',
        //         },
        //         '&::-webkit-scrollbar-thumb': {
        //             background: ThemeColors.greyColor,
        //             borderRadius: 8,
        //         },
        //     },
        // },
        // '& .MuiDrawer-paper': {
        //     background: ThemeColors.babyBlueColor,
        // },
        '& .MuiDrawer-paper::-webkit-scrollbar': {
            width: '0',
        },
    }),
);

const CustomDrawer = ({open, handleDrawerOpen, handleDrawerClose}) => {
    const theme = useTheme();

    // 👇 Detect screen size using MUI's built-in hook
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

    // Automatically close/open drawer when screen size changes
    React.useEffect(() => {
        if (isSmallScreen && open) {
            handleDrawerClose();
        } else if (!isSmallScreen && !open) {
            handleDrawerOpen();
        }
    }, [isSmallScreen]); // only trigger when screen size changes

    return (
        <Drawer variant="permanent" open={open}>
            <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1,
                    background: ThemeColors.babyBlueColor,
                }}
            >
                <CustomDrawerHeader handleDrawerClose={handleDrawerClose}/>
                <Divider/>
            </Box>
            <List sx={{
                flex: 1,
                '& .MuiListItem-root.Mui-selected, & .MuiListItem-root:hover': {
                    color: `${ThemeColors.brandingRed}`,
                },
                '& .MuiListItem-root:hover': {
                    background: 'none',
                    '& .MuiListItemText-root': {
                        // transform: 'scale(1.08)',
                        // marginLeft: '8px'
                    }
                }

            }}>
                {MenuItems?.map((item) => (
                    <DrawerEntry key={item.id} item={item}/>
                ))}
            </List>
            <Box
                sx={{
                    position: "sticky",
                    bottom: 0,
                    zIndex: 1,
                    background: ThemeColors.babyBlueColor,
                }}
            >
                <Divider/>
                <CustomDrawerFooter/>
            </Box>
        </Drawer>
    );
};

export default CustomDrawer;
